import LoginForm from "../../../../publicComponent/LoginForm";
import {useQueryParam} from "../../../../hooks";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";
import {useTranslation} from "react-i18next";
import {HeaderMall9} from "../../../../publicComponent/Header";
import Button from "../../../../publicComponent/Button";
import Navigator from "../../../../publicComponent/h5/Navigator";
import cookies from "../../../../utils/cookies";

function LoginFormMall9(props) {
  const { t, inputHandle, query, loading, login, navigateTo } = props;
  const agentInfo = cookies.getAgentInfo();
  
  const gotoReg = () => {
    navigateTo('/register');
  };
  
  const gotoForgetPwd = () => {
    navigateTo('/forgetPwd');
  };
  
  const loginPress = (e) => {
    if (e.keyCode === 13) {
      login();
    }
  };
  
  return (
    <div className="w-[650px] bg-white mx-auto flex"
         style={{ boxShadow: '0 5px 12px rgba(0,0,0,.15)' }}>
      {/*<div className="w-[375px] flex-none bg-[#333]">*/}
      {/*  <img src={bg}/>*/}
      {/*</div>*/}
      <div className="flex-1 px-[60px] py-[40px] pt-[40px]">
        <h1 className="text-[24px] text-center font-bold mb-[35px]">{t('登录')}</h1>
        <div className="mb-[20px]">
          <label className="text-[14px] hidden mb-[5px] md:block inp-must must-right">
            {agentInfo.isAllowMobileno === '1' && t('手机号') + '/'}{t('邮箱')}
          </label>
          <input type="text"
                 placeholder={`${t('请输入')}${agentInfo.isAllowMobileno === '1'? t('手机号') + '/': '' }${t('邮箱')}`}
                 value={query.account}
                 onKeyDown={loginPress}
                 onChange={(e) => inputHandle(e, 'account')}
                 className="p-[12px] w-[100%] bg-[#f4f4f6] rounded-[5px] text-[15px]"/>
        </div>
        <div className="mb-[40px]">
          <label className="text-[14px] hidden mb-[5px] md:block inp-must must-right">
            {t('密码')}
          </label>
          <input type="password"
                 placeholder={`${t('请输入')}${t('密码')}`}
                 value={query.pwd}
                 onKeyDown={loginPress}
                 onChange={(e) => inputHandle(e, 'pwd')}
                 className="p-[12px] w-[100%] bg-[#f4f4f6] rounded-[5px] text-[15px]"/>
        </div>
        
        <Button className="rounded-[5px] w-[100%] text-white mb-[5px]
                         py-[12px] bg-[#444] text-[14px]"
                loading={loading}
                onClick={login}>{t('登录')}</Button>
        <div className="justify-between flex mdmax:hidden">
          <a onClick={gotoForgetPwd}
             className="link text-[#999] text-[14px]">{t('忘记密码')}?</a>
          <a onClick={gotoReg}
             className="link text-[#999] text-[14px]">{t('注册')}</a>
        </div>
      </div>
    </div>
  );
}

function LoginFormMall9Mobile(props) {
  const { t, inputHandle, query, loading, login, navigateTo, gotoForgetPwd, gotoReg } = props;
  return (
    <>
      <div className="mb-[15px]">
        <label className="text-[14px] hidden mb-[5px] md:block">
          {t('账号')}/{t('手机号')}/{t('邮箱')}
        </label>
        <input type="text"
               placeholder={`${t('请输入')}/${t('账号')} / ${t('手机号')} / ${t('邮箱')}`}
               value={query.account}
               onChange={(e) => inputHandle(e, 'account')}
               className="py-[12px] px-[15px] mdmax:rounded-full container border border-[#d4d4d4] text-[15px]"/>
      </div>
      
      <div className="mb-[10px]">
        <label className="text-[14px] hidden mb-[5px] md:block">
          {t('密码')}
        </label>
        <input type="password"
               placeholder={`${t('请输入')}${t('密码')}`}
               value={query.pwd}
               onChange={(e) => inputHandle(e, 'pwd')}
               className="py-[12px] px-[15px] mdmax:rounded-full container border border-[#d4d4d4] text-[15px]"/>
      </div>
      
      <div className="justify-between flex md:hidden px-[15px]">
        <a className="link text-[14px]" onClick={() => navigateTo('/forgetPwd')}>{t('忘记密码')}?</a>
        <a className="link text-[14px]" onClick={() => navigateTo('/register')}>{t('注册')}</a>
      </div>
      
      <Button className="rounded-none mdmax:rounded-full container
                         py-[12px] bg-[#444] mb-[5px] mt-[60px] text-[15px] bg-[#ECBC40]"
              loading={loading}
              onClick={login}>{t('登录')}</Button>
      <div className="justify-between flex mdmax:hidden">
        <a onClick={gotoForgetPwd}
           className="link text-[#999] text-[14px]">{t('忘记密码')}?</a>
        <a onClick={gotoReg}
           className="link text-[#999] text-[14px]">{t('注册')}</a>
      </div>
    </>
  );
}

export default function Login() {
  const [redirect] = useQueryParam('redirect');
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();
  const agentInfo = cookies.getAgentInfo();
  
  const gobackHandle = () => {
    if (redirect) {
      navigateTo('/');
    } else {
      navigateTo(-1);
    }
  };
  
  return (
    <>
      <div className="md:bg-[#f0f0f0] h-[100vh] mdmax:hidden">
        <HeaderMall9/>
        <div className="flex items-center"
             style={{ height: window.innerHeight - 240 }}>
          <LoginForm>
            {(props) => (<LoginFormMall9 {...props}/>)}
          </LoginForm>
        </div>
      </div>
      <div className="md:hidden">
        <Navigator title={agentInfo.agentName}
                   goback
                   gobackHandle={gobackHandle}/>
        <Navigator.container>
          <div className={'px-[18px]'}>
            <h1 className={'pt-[18%] pb-[10%] text-center text-3xl'}>{t('登录')}</h1>
            <LoginForm>
              {(props) => (<LoginFormMall9Mobile {...props}/>)}
            </LoginForm>
          </div>
        </Navigator.container>
      </div>
    </>
  );
}
